var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getGridStyle = function (token) {
    var _a;
    var componentCls = token.componentCls;
    var colCls = "".concat(componentCls, "-item-col");
    var genGrid = function (grid) {
        return {
            flex: "0 0 ".concat((grid / 24) * 100, "%"),
            maxWidth: "".concat((grid / 24) * 100, "%"),
        };
    };
    var genGrids = function () {
        return Array.from({ length: 24 }, function (_, i) {
            var _a;
            var gridCls = "".concat(colCls, "-").concat(i + 1);
            return _a = {},
                _a[gridCls] = genGrid(i + 1),
                _a;
        }).reduce(function (acc, cur) { return (__assign(__assign({}, acc), cur)); }, {});
    };
    return _a = {},
        _a[componentCls] = __assign({}, genGrids()),
        _a;
};
//# sourceMappingURL=grid.js.map